export const contentData = {
  spanish:{
    layout:{
      title:'Agregar Aseguradora Privada',
      navigation:[
        {name:'Catálogos',path:'/catalogs'},
        {name:'Aseguradoras Privadas',path:'/catalogs/insurace_carriers'},
        {name:'Agregar',path:'/catalogs/insurace_carriers/add'}
      ],
      menu:null
    },
    header:['ID','Nombre','Email','Teléfono','Género']
  }
}